import { apiFetch } from './client.js';

export interface MePayload {
  id: string;
  keycloakId: string;
  username: string;
  name: string;
  email: string;
  role: string;
}

export async function fetchMe(): Promise<MePayload> {
  return apiFetch<MePayload>('/me');
}
